/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react'
import { Controller, useController, useForm } from 'react-hook-form'
import { Box } from '@mui/material'
import { MUIControlledFileInput } from './ControlledFileInput'
import { MUIControlledFileInputV2 } from './ControlledFileInputV2'

const humanSize = (kb) => {
  const bytes = kb * 1024
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  return `${(bytes / (1024 ** i)).toFixed(0)} ${sizes[i]}`
}

const getDefaultMaxSizeErrorMessage = (maxSize) => `File size must be maximum of ${humanSize(maxSize)}`

function MUIFormFileInput({
  control,
  name,
  fileTypes = '*',
  fileTypesDescription,
  required = false,
  maxSize = null,
  maxSizeErrorMessage = null,
  processing = false,
  onChange = () => { },
  showRemoveOption = true,
  gxid = '',
  useNewStyling = false,
  showDescription = true,
  descriptionItems,
  readOnly = false,
  validateFile = () => true,
}) {
  const handleChange = (field) => {
    onChange(field)
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={{}} // eventuially add support for default values
      rules={{
        required: {
          value: required,
          message: 'File is required',
        },
        validate: {
          file: validateFile,
          maxSize: (v) => {
            if (v && maxSize && (v.size / 1024) > maxSize) {
              return maxSizeErrorMessage || getDefaultMaxSizeErrorMessage(maxSize)
            }
            return true
          },
        },
      }}
      render={({ field, fieldState }) => (
        <Box>
          {useNewStyling
            ? (
              <MUIControlledFileInputV2
                name={field.name}
                value={field.value}
                fileTypes={fileTypes}
                fileTypesDescription={fileTypesDescription}
                showRemoveOption={showRemoveOption}
                onChange={(v) => { field.onChange(v); handleChange(field) }}
                invalid={fieldState.invalid}
                processing={processing}
                innerRef={field.ref}
                gxid={gxid}
                showDescription={showDescription}
                descriptionItems={descriptionItems}
              />
            )
            : (
              <MUIControlledFileInput
                name={field.name}
                value={field.value}
                fileTypes={fileTypes}
                fileTypesDescription={fileTypesDescription}
                showRemoveOption={showRemoveOption}
                onChange={(v) => { field.onChange(v); handleChange(field) }}
                invalid={fieldState.invalid}
                processing={processing}
                innerRef={field.ref}
                gxid={gxid}
                readOnly={readOnly}
              />
            )}
          <Box sx={{ color: '#bd2326', fontSize: '.875rem', marginTop: '0.25rem' }}>
            {fieldState.error?.message}
          </Box>
        </Box>
      )}
    />
  )
}

export { getDefaultMaxSizeErrorMessage, MUIFormFileInput }
